import Vuex from "vuex";
import { appModule } from "./modules/app_module";

export const store = new Vuex.Store({
  modules: {
    app: appModule,
  },
});
